import { useId, type ReactNode } from 'react';

interface InfoBadgeProps {
  children: ReactNode;
  className?: string;
  label?: string;
}

export function InfoBadge({ children, className, label = 'More information' }: InfoBadgeProps) {
  const tooltipId = useId();
  const rootClassName = className ? `info-badge ${className}` : 'info-badge';

  return (
    <span className={rootClassName}>
      <button
        type="button"
        className="info-badge-trigger"
        aria-label={label}
        aria-describedby={tooltipId}
      >
        <span aria-hidden="true" className="info-badge-icon">
          i
        </span>
      </button>
      <span role="tooltip" id={tooltipId} className="info-badge-tooltip">
        {children}
      </span>
    </span>
  );
}
